import { telehealthSend } from "@utils/fetch";
import { appConfig } from "src/config";
import { GetTreatmentsResponseProto } from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/treatment_query_service";

export const getNonTerminalTreatments = async (
  accessCode: string
): Promise<GetTreatmentsResponseProto> => {
  const url = `${appConfig.HEALTHCARE_SERVICE_API_BASE_URL}/v1/patient/${accessCode}/treatments/nonTerminal`;
  return telehealthSend("GET", url);
};
